module.exports = __webpack_public_path__ + "img/loading.3a6ae13b.png";